import $ from 'jquery';

import UploadWidget from './module/upload-wIdget';
import SearchWidget from './module/search-widget';
import { ColorPicker } from './module/colorpick';
import OrderModal from './module/order-modal';
import CustomerSwap from './module/customer-swap';
import CustomerEditConfirmModal from './module/customer-edit-confirm-modal';
import Collection from './module/collection-widget';
import DeviceFormFields from './module/device-create-widget';
import ToggleAllWidget from './module/toggle-all-widget';
import CallCenter from './module/call-center';
import DeviceAssign from './module/call-center-device-assign';
import LegalInfo from './module/legal-info-submit';
import AjaxLoadCustomerMenus from './module/ajax-load-customer-menus';
import ConfirmModal from './module/confirm-modal';
import GiftCategoryTree from './module/gift-category-tree';
import GiftCategoryVariant from './module/gift-category-variant';
import BlockSort from './module/block-sort';
import SortItemsAssign from './module/sort-items-assign';
import TimePicker from './module/timepicker';
import StoreLocatorCustomWorkTimeFrom from './module/store-locator-custom-work-time-from';
import StoreLocatorPinForm from './module/store-locator-pin-form';
import AdminBulkAction from './module/admin-bulk-action';
import InputsLogic from './module/inputs-logic';
import ShowOnSelectValue from './module/show-on-select-value';
import ProductTypeSelect from './module/product-type-select';
import OrderProductTypeSelect from './module/order-product-type-select';
import TradeInOrderCreate from './module/trade-in-order-create';
import { DisableTargetOnValue } from './components/disable-target-on-value';
import FormValidation from './module/form-validation';
import AjaxModal from './module/ajax-modal';
import CampaignForm from './module/campaign-form';
import AjaxContent from './components/ajax-content.ts';
import AjaxForm from './components/ajax-form';
import OrderSummary from './components/order-summary';
import RichTextEditor from './module/rich-text-editor';
import ClearableDropdown from './components/clearable-dropdown';
import CustomerCode from './module/customer-code';
import { DisableOnTargetValue } from './components/disable-on-target-value';
import { SetInputValueOnTargetValue } from './components/set-input-value-on-target-value';
import PasswordVisibilityToggle from './components/password-visibility-toggle';
import './module/promotion/index';
import { GenerateSlug } from './components/generate-slug';
import { SumFieldValues } from './components/sum-field-values';
import { SortableTable } from './components/sortable-table';
import { TabsDropdown } from './components/tabs-dropdown';
import { TableFormJson } from './components/table-from-json';
import { AddTextToField } from './components/add-text-to-field';
import { MirrorInputValueToElement } from './components/mirror-input-value-to-element';
import { InitialOrderSearch } from './components/initial-order-search';
import { CodeMirrorEditor } from './components/code-mirror-editor';
import { EmailTemplates } from './components/email-templates';
import CopyInputValue from './components/copy-value';
import { ConfirmLinkModal } from './components/confirm-link-modal';
import { OrderNumber } from './components/order-number';
import { DataLimitsOnTargetValue } from './components/data-limits-on-target-value';
import { ActionButtons } from './components/action-buttons';
import { AjaxPagination } from './components/ajax-pagination';
import { SetValueOnClick } from './components/set-value-on-click';
import { VisibleFieldsByConditions } from './components/visible-fields-by-conditions';
import { RequiredOnTargetValue } from './components/required-on-target-value';
import { Tooltip } from './components/tooltip';
import { NumberInput } from './components/number-input';
import SelectAllInput from './components/select-all-input';
import { TabsWithCheckbox } from './components/tabs-with-checkbox';
import { SoftValidationMessages } from './components/soft-validation-messages';
import AjaxButton from './components/ajax-button';
import { TabsWithLinks } from './components/tabs-with-links';
import { CollectionItemsOrder } from './components/collection-items-order';
import { CollectionItemsValuesOnChange } from './components/collection-items-default-value';
import SetDropdownValue from './components/set-dropdown-value';
import GiftClaimSummary from './components/gift-claim-summary';
import { CollectionMaxItems } from './components/collection-max-items';
import { KeepElementScroll } from './components/keep-element-scroll';
import LazyImages from './components/lazy-images';
import { HideDropdownOptionsOnTargetValue } from './components/hide-dropdown-options-on-target-value';
import { KeepInputValue } from './components/keep-input-value';
import { CustomerSearch } from './components/customer-search';
import FileSizeValidation from './components/file-size-validation';
import SelectOnlyOneValue from './components/select-only-one-value';
import { FilterPromotionsByProduct } from './components/filter-promotions-by-product';
import { ChangeLabelOnValue } from './components/change-label-on-value';
import NegativeInput from './components/negative-input';
import GridModalLoader from './module/grid-modal-loader';
import { CheckboxTreeSync } from './components/checkbox-tree-sync';

(function () {
  'use strict';

  /**
   * Upload button init
   */
  UploadWidget.init();

  /**
   * Adds search function in select dropdowns
   */
  SearchWidget.init();

  $('.js__add-action').on('click', () => {
    setTimeout(() => {
      SearchWidget.init();
      $('.js__file-upload').each((index, element) => {
        $(element).fileUpload();
      });
      RichTextEditor.init();
    }, 100);
  });

  /**
   * Colorpicker init
   */
  ColorPicker.init();

  RichTextEditor.init();

  /**
   * Order modal init
   */
  OrderModal.init();

  /**
   * Customer swap
   */
  CustomerSwap.init();
  /**
   * Collection init
   */
  Collection.init();

  /**
   * Handles dive form
   */
  DeviceFormFields.init();

  /**
   * Init toggle all widget
   */

  ToggleAllWidget.init();

  /**
   * Init CallCenter
   */
  CallCenter.init();

  /**
   * Init Grid modal loader
   */
  GridModalLoader.init();

  /**
   * Init DeviceAssign
   */
  DeviceAssign.init();

  /**
   * Init toggle all widget
   */

  LegalInfo.init();

  /**
   * Init TimePicker
   */
  TimePicker.init();

  /**
   * Init StoreLocatorCustomWorkTimeFrom
   */
  StoreLocatorCustomWorkTimeFrom.init();

  /**
   * Init StoreLocatorPinForm
   */
  StoreLocatorPinForm.init();

  /**
   * Init AdminBulkAction
   */
  AdminBulkAction.init();

  /**
   * Init InputsLogic
   */
  InputsLogic.init();

  /**
   * Init ShowOnSelectValue
   */
  ShowOnSelectValue.init();

  DisableTargetOnValue.init();

  SelectAllInput.init();

  GenerateSlug.init();

  SetInputValueOnTargetValue.init();

  HideDropdownOptionsOnTargetValue.init();

  MirrorInputValueToElement.init();

  DisableOnTargetValue.init();

  InitialOrderSearch.init();

  CustomerSearch.init();

  DataLimitsOnTargetValue.init();

  SumFieldValues.init();

  CustomerCode.init();

  CampaignForm.init();

  AddTextToField.init();

  CodeMirrorEditor.init();

  EmailTemplates.init();

  CopyInputValue.init();

  ConfirmLinkModal.init();

  OrderNumber.init();

  ActionButtons.init();

  AjaxPagination.init();

  SetValueOnClick.init();

  VisibleFieldsByConditions.init();

  RequiredOnTargetValue.init();

  Tooltip.init();

  NumberInput.init();

  TabsWithCheckbox.init();
  CheckboxTreeSync.init();

  AjaxButton.init();

  /**
   * Init sortable table actions and styles
   */
  SortableTable.init();

  TabsDropdown.init();

  /**
   * Init product edit regular/bundle select view
   */
  ProductTypeSelect.init();

  /**
   * Init product edit regular/bundle select view
   */
  OrderProductTypeSelect.init();

  TradeInOrderCreate.init();

  ClearableDropdown.init();

  SoftValidationMessages.init();

  /**
   * Init  AjaxLoadCustomerMenus
   */
  AjaxLoadCustomerMenus.init();

  $('.js__modal-open-on-load').modal('show');

  AjaxForm.init();

  FormValidation.init();

  PasswordVisibilityToggle.init();

  TableFormJson.init();

  CollectionItemsOrder.init();

  CollectionItemsValuesOnChange.init();

  new GiftCategoryTree();

  new GiftCategoryVariant('.js__sortable-init');

  new BlockSort('.js__gift-variant-sort-init');

  new BlockSort('.js__product-images-sort-init');

  new BlockSort('.js__qure-buttons-sort-init');

  OrderSummary.init();

  GiftClaimSummary.init();

  AjaxModal.init();

  var $mgmConfirmModal = $('.js__call-confirm-modal');
  new ConfirmModal(
    $mgmConfirmModal,
    () => parseInt($mgmConfirmModal.data('is-eligible'), 10),
    $('.js__confirm-chose-modal'),
    $('.js__enroll-form'),
  ).init();

  new ConfirmModal(
    $('.js__call-age-verification-confirm-modal'),
    () => $('.js__age-verification-status select').val() !== 'declined',
    $('.js__age-verification-confirm-modal'),
    $('.js__age-verification-form'),
    true,
  ).init();

  new ConfirmModal(
    $('.js__confirm-modal-button'),
    () => {},
    $('.js__confirm-modal'),
    $('.js__confirm-modal-form'),
    true,
  ).init();

  CustomerEditConfirmModal.init();

  new SortItemsAssign();

  TabsWithLinks.init();

  AjaxContent.init();

  SetDropdownValue.init();

  CollectionMaxItems.init();

  KeepElementScroll.init();

  LazyImages.init();

  KeepInputValue.init();

  FileSizeValidation.init();

  SelectOnlyOneValue.init();

  FilterPromotionsByProduct.init();

  ChangeLabelOnValue.init();

  NegativeInput.init();
})();
